import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {Redirect, Switch} from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';

import MainApp from 'routes/app'
import FormsApp from "routes/app/components/FormsApp";
import PageRegister from 'routes/register/'
import Framework from '@beardeddevops/react.framework';
import PageForgotPassword from 'routes/forgot-password/'
import PageLogin from 'routes/login/'

import 'react-toastify/dist/ReactToastify.css';
import '@beardeddevops/react.framework/dist/index.css';
import lightTheme from './themes/lightTheme';
import 'constants/Styles.scss';

import API from '@beardeddevops/react.api';
import APPCONFIG from "../constants/Config";
import Types from 'constants/Types';
import {defaultState} from 'constants/State';

import Cookies from 'universal-cookie';

import ErrorBoundaryRoute from './ErrorBoundaryRoute';
//TODO: move into react.api probs
import {version} from '../../public/meta.json';
import {Objects} from "../components";
import UserRoles from "../constants/UserRoles";

export default class App extends Component {

	constructor(props) {
		super(props);

		API.URL = APPCONFIG.settings.apiURL();
		API.Version = APPCONFIG.settings.apiVersion;
		API.setAJAXDefaults(this, toast);

		this.state = {
			shouldReloadCart: false,
			scannedCode: "",
			startLoading: false,
			x: 0,
			y: 0,
			notifications: [],
			badges: {},
			initialRouting: false
		};

		// noinspection JSUnusedGlobalSymbols
		this.scanner_current_product = "";
		this.sessionCheckingInitialized = false;
		this.check = this.info = null;

		this.googlePlacesPromise = null;
		this.googlePlacesLoaded = false;

		//this.onMouseMove = this.onMouseMove.bind(this);

		if (this.props.rootState.shouldCacheBust) {
			window.onbeforeunload = function () {
				window.localStorage.clear();
			}
		}
	}

	loadGooglePlaces = async () => {
		if (this.googlePlacesLoaded || window.google?.maps?.places) {
			this.googlePlacesLoaded = true;
			return true;
		}

		if (this.googlePlacesPromise) {
			return this.googlePlacesPromise;
		}

		this.googlePlacesPromise = new Promise((resolve, reject) => {
			const existing = document.getElementById('google-maps-places-script');

			if (existing) {
				if (window.google?.maps?.places) {
					this.googlePlacesLoaded = true;
					resolve(true);
					return;
				}

				const handleLoad = () => {
					if (window.google?.maps?.places) {
						this.googlePlacesLoaded = true;
						resolve(true);
					} else {
						reject(new Error('Google Maps loaded but Places library was unavailable.'));
					}
				};

				const handleError = () => {
					reject(new Error('Failed to load Google Maps Places script.'));
				};

				existing.addEventListener('load', handleLoad, { once: true });
				existing.addEventListener('error', handleError, { once: true });
				return;
			}

			const key = APPCONFIG.settings.GOOGLE_MAPS_API_KEY();

			if (!key) {
				reject(new Error('Missing Google Maps API key.'));
				return;
			}

			const script = document.createElement('script');
			script.id = 'google-maps-places-script';
			script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
			script.async = true;
			script.defer = true;

			script.onload = () => {
				if (window.google?.maps?.places) {
					this.googlePlacesLoaded = true;
					resolve(true);
				} else {
					reject(new Error('Google Maps loaded but Places library was unavailable.'));
				}
			};

			script.onerror = () => {
				reject(new Error('Failed to load Google Maps Places script.'));
			};

			document.head.appendChild(script);
		});

		return this.googlePlacesPromise;
	}

	async componentDidMount() {

		let {rootState, history} = this.props;

		this.rootStateID = rootState.subscribe({
			name: null,
			roles: null,
			showSideBar: null,
			getUserInformation: this.getUserInformation,
			handleSessionCheck: this.handleSessionCheck,
			logout: this.handleLogout,
			latitude: null,
			longitude: null,
			shouldCacheBust: false,
			lastDetailRequest: 0
		});

		try {
			await API.loadOptions(false, API.Version);
		} catch (e) {
			// console.log('Error loading options:', e);
			return;
		}

		this.check = new API.BuildClass(Types.Accounts._name, 'GET_CHECK');
		this.info = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);

		try {
			await this.loadGooglePlaces();
		} catch (e) {
			console.error('Error loading Google Places:', e);
			API.Toast.error('Unable to load address autocomplete right now.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
		}

		await this.getUserInformation({fromRouteChange: false, forceTrigger: false});

		this.setState({startLoading: true});

		history.listen(async (location) => {
			// console.log('Navigating to ' + location.pathname);
			await this.getUserInformation({fromRouteChange: true, forceTrigger: false});
		});
	}

	componentWillUnmount() {
		this.props.rootState.unsubscribe(this.rootStateID);
	}

	handleLogout = () => {
		if (!window.location.href.split('/').includes('forms')) {
			let cookies = new Cookies();
			cookies.remove('auth_pkey');
			cookies.remove('hash');
			this.props.rootState.set({...defaultState});
			this.props.history.push('/login');
		}
	}

	getUserInformation = async ({fromRouteChange = false, forceTrigger = false}) => {
		const {rootState} = this.props;

		let lastExecuted = rootState.lastDetailRequest !== 0 ? rootState.lastDetailRequest : Date.now() - 60000;
		const shouldRoutePassword = rootState.temp_password;
		const shouldRouteApprovals = rootState.last_approved_week !== false && rootState.last_approved_week !== null && !shouldRoutePassword;

			const currentTime = Date.now();
			// Check if 60 seconds have passed
			if ((currentTime - lastExecuted >= 60000) || forceTrigger || (shouldRoutePassword && !window.location.href.includes("users")) || (shouldRouteApprovals && !window.location.href.includes("approvals"))) {
				// Execute the function

				let info = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
				let data;

				if (!window.location.href.split('/').includes('forms') && !window.location.href.includes('karlstechnology.com/login?onboarding=true')) {
					try {
						let cookies = new Cookies();
						if (cookies.get('auth_pkey')) {
							info.filter = {'secure_auth': cookies.get('hash'), 'auth_pkey': cookies.get('auth_pkey')}
						}
						data = await info.submit(null, 'GET_DETAILS');
					} catch (e) {
						// console.log('getUserInformation error', e);
						if (!fromRouteChange) this.props.history.push('/login')
						return;
					}
					if (!data) {
						return;
					}
					if (data.main_role) {
						localStorage.setItem('main_role', data.main_role);
					}
					//if data exists then set rootState
					await rootState.set({
						name: data.name_first + ' ' + data.name_last,
						roles: data.roles,
						user: data.user,
						shouldCacheBust: parseInt(data.version.replaceAll('.', '')) > parseInt(version.replaceAll('.', '')),
						active: data.active,
						isIdle: data.isIdle,
						current_activity: data.current_activity,
						main_role: data.main_role,
						fe_work_order_amount: data.fe_work_order_amount ?? null,
						lastDetailRequest: currentTime,
						favorites: data.favorites,
						last_approved_week: Object.keys(data).includes('last_approved_week') ? data.last_approved_week : false,
						badge: 1,
						temp_password: data.temp_password
					});


					if ((data.temp_password && !window.location.href.includes("users")) || shouldRoutePassword) {
						//engineers reroute
						this.props.history.push({
							pathname: '/users/' + data.user
						})
						return;
					} else if (data.main_role === 500 && data.last_approved_week === null) {
						this.props.history.push({
							pathname: '/dataEntry',
							state: {user: data.user}
						})
					} else if ((Object.keys(data).includes('last_approved_week') ? data.last_approved_week !== null : false) && !window.location.href.includes("approvals") && shouldRouteApprovals && !(shouldRoutePassword && window.location.href.includes("users"))) {
						if (data.main_role === 40) {
							//engineers reroute
							this.props.history.push({
								pathname: '/engineers/approvals',
								state: {initialDate: data.last_approved_week}
							})
						} else {
							this.props.history.push({
								pathname: '/schedule_approvals/self',
								state: {initialDate: data.last_approved_week}
							})
						}
						return;
					}

					const isMobile = window.innerWidth <= 768;

					if (data.main_role === 10 && isMobile && this.state.initialRouting === false) {
						this.props.history.push({
							pathname: '/managers'
						})
						this.state.initialRouting = true;
					}

					if (data.activeDispatchers) {
						window.localStorage.setItem('activeDispatchers', JSON.stringify(data.activeDispatchers))
					} else {
						window.localStorage.setItem('activeDispatchers', JSON.stringify([]))
					}
					if (data.activeHelpdesks) {
						window.localStorage.setItem('activeHelpdesks', JSON.stringify(data.activeHelpdesks))
					} else {
						window.localStorage.setItem('activeHelpdesks', JSON.stringify([]))
					}
					if (data.activeHirings) {
						window.localStorage.setItem('activeHirings', JSON.stringify(data.activeHirings))
					} else {
						window.localStorage.setItem('activeHirings', JSON.stringify([]))
					}

					//if data.shouldCacheBust is true then set an interval for this toast every 5 minutes
					if (!APPCONFIG.settings.isDev()) {
						if (this.props.rootState.shouldCacheBust) {
							if (!this.state.cacheInterval) {
								API.Toast.info('A new version is available, please refresh when you are able to.', {
									position: API.Toast.POSITION.TOP_RIGHT
								}); //Initial toast

								this.state.cacheInterval = setInterval(() => {
									API.Toast.info('A new version is available, please refresh when you are able to.', {
										position: API.Toast.POSITION.TOP_RIGHT
									});
								}, 300000)
							}
						}
					}

					// Now derive from backend flags
					this.setLocalFlags(data)
					// Initialize services depending on an authenticated session
					await this.initSessionChecks();

					//returning data is for getting it from the triggerAction, used for popping dispatch time tracking modal
					return data;
				}
			}
	}

	handleSessionCheck = async () => {
		let lockedLocations = ['/login', '/register', '/forgot-password'];

		let {rootState, location, history} = this.props;
		let data;

		try {
			data = await this.check.submit(null, 'GET_CHECK');
		} catch (e) {
			console.log('handleSessionCheck error: ', e);
		}

		if (!data) {
			return;
		}

		//set active, notifications & badges (only keep keys with count > 0 so cleared badges disappear)
		const KNOWN_BADGE_KEYS = ['final_numbers', 'dd_info_updated', 'pendings', 'new_hires', 'pending_tors', 'pending_edits', 'pending_cards', 'missing_financial'];
		const rawBadges = data?.badges && !Array.isArray(data.badges) ? data.badges : {};
		const badges = {};
		KNOWN_BADGE_KEYS.forEach((key) => {
			const n = Number(rawBadges[key]);
			if (n > 0) {
				badges[key] = n;
			}
		});
		const type11Count = (Array.isArray(data.notifications) ? data.notifications : [])
			.filter((item) => Number(item.Type ?? item.type) === 11).length;
		if (type11Count > 0) {
			badges.missing_financial = type11Count;
		}
		const notifications = Array.isArray(data.notifications)
			? data.notifications
			: this.state.notifications;
		this.setState({active: data.active, notifications, badges: badges});

		if (Array.isArray(data.notifications) && data.notifications.filter((item) => item.Type == 3).length > 0) {
			API.Toast.info('New Tawk.to notification!', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
		}

		if (JSON.stringify(data.thermometer_data) !== JSON.stringify(this.state.thermometer_data)) {
			this.setState({thermometer_data: data.thermometer_data})
		}

		// If you're on a locked location but logged in, then redirect
		if (lockedLocations.includes(location.pathname)) {
			history.push('/');
		} else if (data) {
			const keys = ['pending_count', 'pending_trend', 'dispatch_count', 'dispatch_trend'];
			keys.forEach((key) => {
				if (data[key]) {
					window.localStorage.setItem(key, data[key]);
				} else {
					if (key.includes('trend')) {
						window.localStorage.setItem(key, 'same');
					} else {
						window.localStorage.setItem(key, 0);
					}
				}
			})
			if (data.activeDispatchers) {
				window.localStorage.setItem('activeDispatchers', JSON.stringify(data.activeDispatchers))
			} else {
				window.localStorage.setItem('activeDispatchers', JSON.stringify([]))
			}
			if (data.activeHelpdesks) {
				window.localStorage.setItem('activeHelpdesks', JSON.stringify(data.activeHelpdesks))
			} else {
				window.localStorage.setItem('activeHelpdesks', JSON.stringify([]))
			}
			if (data.activeHirings) {
				window.localStorage.setItem('activeHirings', JSON.stringify(data.activeHirings))
			} else {
				window.localStorage.setItem('activeHirings', JSON.stringify([]))
			}
			rootState.set({
				roles: data.roles,
				active: data.active,
				isIdle: data.isIdle,
				main_role: data.main_role
			});
			// Now derive from backend flags
			this.setLocalFlags(data)
			// if (data.grade_score_hour) {
			// 	this.setState({grade_score_hour: data.grade_score_hour})
			// }
			// if (data.grade_score_day) {
			// 	this.setState({grade_score_day: data.grade_score_day})
			// }
		}
	}

	setLocalFlags = (data) => {
		const { active, isIdle } = data;

		// AFK always wins
		if (active === false) {
			localStorage.setItem("timeTrackingModal", "true");
			localStorage.setItem("idleModal", "false");
			return;
		}

		// Idle only
		if (isIdle === true) {
			localStorage.setItem("idleModal", "true");
			localStorage.setItem("timeTrackingModal", "false");
			return;
		}

		// Neither
		localStorage.setItem("timeTrackingModal", "false");
		localStorage.setItem("idleModal", "false");
	};


	initSessionChecks = async () => {
		if (this.sessionCheckingInitialized) return;

		await this.handleSessionCheck();

		setInterval(async () => {
			await this.handleSessionCheck();
		}, 60000);

		this.sessionCheckingInitialized = true;
	}

	render() {
		const {match, location, rootState} = this.props;
		let {startLoading} = this.state;
		let materialUITheme = lightTheme;
		let {name} = rootState;
		const isRoot = location.pathname === '/';
		if (isRoot) {
			API.NoLoggedInNotice = false;
			//leave this commented out, it makes it load twice
			//return (<Redirect to={'/dashboard'}/>);
		}
		return (
			<MuiThemeProvider theme={createMuiTheme(materialUITheme)}>

				<div id={"app-inner"}>
					<div className="preloaderbar hide">
						<span className="bar"/>
					</div>
					<div className='app-main full-height fixed-header sidebar-sm'>
						{name ?
							<Switch>
								<ErrorBoundaryRoute path={`${match.url}`}>
									<MainApp
										shouldReloadCart={this.state.shouldReloadCart}
										scannedCode={this.state.scannedCode}
										thermometer_data={this.state.thermometer_data ?? null}
										active={this.state.active ?? null}
										notifications={this.state.notifications}
										badges={this.state.badges}
									/>
								</ErrorBoundaryRoute>
								<Redirect to={"/"}/>
							</Switch> : startLoading ?
								<Switch>
									<ErrorBoundaryRoute exact path="/login">
										<PageLogin/>
									</ErrorBoundaryRoute>

									<Switch>
										<ErrorBoundaryRoute exact path="/login">
											<PageLogin/>
										</ErrorBoundaryRoute>

										<ErrorBoundaryRoute exact path="/register">
											<PageRegister/>
										</ErrorBoundaryRoute>

										<ErrorBoundaryRoute exact path="/forgot-password">
											<PageForgotPassword/>
										</ErrorBoundaryRoute>
										<Redirect to={"/login"}/>
									</Switch>
								</Switch>
								:
								<Framework.Elements.LoadingSpinner isLoading={true}/>
						}

						<ToastContainer autoClose={10000} style={{textAlign: "center"}} newestOnTop draggable={false}/>
					</div>
				</div>
			</MuiThemeProvider>
		);
	}
}

App = Framework.Components.withRootState(App);
